import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlMutation } from 'src/graphql/client';
import { BRIEF_TYPE } from 'src/data/brief';
import { BRIEF_FRAGMENT } from 'src/graphql/brief';

const MUTATION = gql`
  mutation UpdateProjectBriefContent(
    $projectId: ID!
    $title: String
    $article: String
    $freeText: String
    $emailPromotion: String
  ) {
    updateProjectBriefContent(
      projectId: $projectId
      title: $title
      article: $article
      freeText: $freeText
      emailPromotion: $emailPromotion
    ) {
      id
      brief {
        ...Brief
      }
    }
  }
  ${BRIEF_FRAGMENT}
`;

const mapBriefContent = (briefType, briefContent) => {
  switch (briefType) {
    // "unified" briefs already have required schema
    case BRIEF_TYPE.unifiedContent:
    case BRIEF_TYPE.unifiedProduct:
    case BRIEF_TYPE.unifiedPromotionalEmail:
      return briefContent;

    case BRIEF_TYPE.email:
      return {
        article: briefContent.body,
      };

    case BRIEF_TYPE.socialManual:
      return {
        article: briefContent.body,
      };

    case BRIEF_TYPE.shopifyProductBrief:
      return {
        title: briefContent.productName,
        article: briefContent.body,
      };

    case BRIEF_TYPE.canvas:
      return {
        title: briefContent.title,
        article: briefContent.body,
        freeText: briefContent.freeText,
      };

    default:
      return null;
  }
};

export const updateProjectBriefContent = ({ projectId, briefType, briefContent }) => {
  const mappedContent = mapBriefContent(briefType, briefContent);

  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      projectId,
      ...mappedContent,
    },
  }).then(({ data }) => getSingleProp(data));
};
